import React from "react";
import {
  Input,
  Label,
  Checkbox,
  Icon,
  Popup,
  Button,
  Segment,
  Modal,
  Grid,
  Message
} from "semantic-ui-react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  resetCustomField,
  saveCustomField
} from "../../actions/customFields/saveAndCancelCustomField";
import {
  createNotification,
  NOTIFICATION_TYPE_ERROR
} from "react-redux-notify";
import { customFieldEdited } from "../../actions/customFields/editCustomFields";
import { ReactSortable } from 'react-sortablejs';
import svg_icon_path from "../../static/media/SVGSpriteIcon.svg";

class DropDownSettings extends React.Component {
  constructor(props) {
    super(props);
    this.errorNotification = {
      type: NOTIFICATION_TYPE_ERROR,
      duration: 5000,
      canDismiss: true
    };
    this.state = {
      error: false,
      options: [],
      originalOptions: [],
      open: false,
      searchEnteredValue: "",
      showAddOptionsPopup: false
    };

    this.addTxtRef = React.createRef();
    this.optionsSegment = React.createRef();
  }

  onClickApplyHandler = () => {
    if (!this.props.isCfieldsedited) {
      this.props.customFieldEdited(true);
    }
    let _originalOptions = this.state.originalOptions;


    this.props.customField.customFieldOptions = this.state.originalOptions;
    this.props.customField.isSingleSelectOptionsEdited = true;
    this.setState({
      open: false,
      options: [],
      originalOptions: []
    });
  };

  onClickCancelHandler = () => {
    this.setState({
      options: [],
      originalOptions: [],
      open: false
    });
  };

  handlePopUpOpen = () => {
      var fieldOptions = JSON.stringify(
          this.props.customField.customFieldOptions
      );
      try {
          this.setState({
              open: true,
              options: JSON.parse(fieldOptions),
              originalOptions: JSON.parse(fieldOptions),
              showAddOptionsPopup: false,
              error: false,
              searchEnteredValue: ""
          });
      } catch (e) {
          console.error('Invalid JSON input:', e.message);
          window.location.href = "/webapp/notauth";
          return

      }
  };

  handleAddOptionChange(event) {
    if (event.target.value.length >= 50) {
      this.setState({ error: false, showAddOptionsPopup: true });
    } else {
      this.setState({ error: false, showAddOptionsPopup: false });
    }
  }
  _handleKeyDown(e) {
    if (e.keyCode === 13) {
      this.addCustomFieldOption();
    }
  }

  handleOptionChk(cfTobeChanged, data) {
    this.state.originalOptions.map(a => {
      if (a.optionName === cfTobeChanged.optionName) {
        a.isOptionEnabled = data.checked;
      }
    });
    this.setState(state => {
      var prvState = state;
      prvState.options.map(a => {
        if (a.optionName === cfTobeChanged.optionName) {
          a.isOptionEnabled = data.checked;
        }
      });
      return prvState;
    });
  }

  handleSearchFieldChange(event, data) {
    let filterResult = this.state.originalOptions.filter(option => {
      if (
        option.optionName.toLowerCase().indexOf(data.value.toLowerCase()) > -1
      )
        return option;
    });
    this.setState({ options: filterResult, searchEnteredValue: data.value });
  }

  handleAddOptionPopUpOpen = () => {
    if (this.addTxtRef.current.value.length >= 50) {
      this.setState({ showAddOptionsPopup: true });
    } else {
      this.setState({ showAddOptionsPopup: false });
    }
  };

  handleAddOptionPopUpClose = () => {
    this.setState({ showAddOptionsPopup: false });
  };
  handleOnMove(evt, orgevt, sortable, store) {
    //console.log('on move', sortable, store)
  }
  handleSetList = (newState) => {
    console.log('handle set list', newState);
    let _newState = [...newState];
    let _originalOptions = [...this.state.originalOptions]
    let _orderState = _newState.map((option, i) => {
      option.orderID = i + 1;
    })
    if (_orderState.length === _originalOptions.length) {
      this.setState({ options: newState, originalOptions: newState })
    }

  }
  buildOptions(hideSortIndicator) {

    return (
      this.state.options.map((option, i) => (
        <Input
          key={option.optionID}
          labelPosition='left'
          fluid type='text'
          value="Amount"
          placeholder='Amount'
          className={
            option.isOptionEnabled
              ? "compact attachedLabel"
              : "compact attachedLabel unchecked"
          }>
          <Label className="d-flex align-items-center">
            <Checkbox
              checked={option.isOptionEnabled}
              onChange={(event, data) => {
                this.handleOptionChk(option, data);
              }} />
          </Label>
          <label className="option d-flex">
            <span class="w-95per">{option.optionName}</span>
            <svg
              className={hideSortIndicator ? "d-none" : "svg_icon xcm-icon-hamburger-menu size-20 ml-auto c-grab mr-negative-8"}
            >
              <use xlinkHref={`${svg_icon_path}#xcm-icon-hamburger-menu`}> </use>
            </svg>
          </label>
        </Input>
      ))
    );

  }

  addCustomFieldOption() {
    let _this = this;
    let _originalOptions = this.state.originalOptions;
    if (this.addTxtRef.current.value.trim() !== "") {
      let listItem = this.addTxtRef.current.value.trim();
      let exists = [
        ...new Set(
          _originalOptions.filter(
            a => a.optionName.trim() === listItem.trim()
          )
        )
      ];

      if (exists.length) {
        this.setState({
          error: true
        });
        const existsNotification = {
          message: `There is a dropdown option that already exists with this name. Please try a different name.`,
          ...this.errorNotification
        };
        this.props.createNotification(existsNotification);
      } else {
        let obj = {
          fieldID: this.props.customField.fieldID,
          optionID: _originalOptions.length + 1,
          orderID: _originalOptions.length + 1,
          optionName: listItem,
          isOptionEnabled: true
        };
        this.state.originalOptions.push(obj);
        let filterResult = this.state.originalOptions.filter(option => {
          if (
            option.optionName
              .toLowerCase()
              .indexOf(_this.state.searchEnteredValue.toLowerCase()) > -1
          )
            return option;
        });
        this.setState({
          options: filterResult,
          error: false,
          showAddOptionsPopup: false
        });
        this.addTxtRef.current.value = "";
        if (this.state.options.length > 1) {
          const scrollHeight = this.optionsSegment.current.scrollHeight;
          const height = this.optionsSegment.current.clientHeight;
          this.optionsSegment.current.scrollTop = scrollHeight + 100;
        }

      }
    } else {
      this.setState({
        error: true
      });
      const existsNotification = {
        message: `Please fill in a Dropdown Option Name.`,
        ...this.errorNotification
      };
      this.props.createNotification(existsNotification);
    }
  }

  render() {
    let _optionsList = null;

    _optionsList = this.state.options.length ?
      <div ref={this.optionsSegment} className="scrolling_content h-250 p-8">
        {this.state.searchEnteredValue === "" ?
          <ReactSortable
            list={this.state.options}
            setList={this.handleSetList}
          >
            {this.buildOptions(false)}
          </ReactSortable>
          :
          this.buildOptions(true)
        }
      </div>
      : <Message>No options available</Message>

    return (
      <Modal
        on="click"
        trigger={
          <svg
            className={
              this.props.customField.isSingleSelectOptionsEdited &&
                this.props.isCfieldsedited
                ? "svg_icon xcm-icon-settings size-24 orange"
                : "svg_icon xcm-icon-settings size-24"
            }>
            <title> xcm-icon-settings</title>
            <use xlinkHref={`${svg_icon_path}#xcm-icon-settings`}> </use> </svg>
        }
        position="right center"
        open={this.state.open}
        onOpen={this.handlePopUpOpen.bind(this)}
        size={"mini"}
        closeOnDimmerClick={false}
      >
        <Modal.Header className="d-flex">
          {this.props.customField.fieldName.length >= 19
            ? this.props.customField.fieldName.substring(0, 16) + "..."
            : this.props.customField.fieldName} {" "}
                Options
          <div className="ml-auto">
            <svg class="svg_icon xcm-icon-close size-24"
              onClick={this.onClickCancelHandler.bind(this)}>
              <use xlinkHref={`${svg_icon_path}#xcm-icon-close`} >
              </use>
            </svg>
          </div>
        </Modal.Header>
        <Modal.Content>
          <Popup
            on={"hover"}
            trigger={
              <Input
                error={this.state.error}
                actionPosition="right"
                onChange={this.handleAddOptionChange.bind(this)}
                onKeyDown={this._handleKeyDown.bind(this)}
                type="text"
                maxLength="50"
                placeholder="Add Options"
                fluid
              >
                <input ref={this.addTxtRef} />
                {/* <input  ref={this.addTxtRef}  onKeyDown={this._handleKeyDown.bind(this)}/> */}
                <Button icon onClick={this.addCustomFieldOption.bind(this)}>
                  <Icon name="plus" />
                </Button>
              </Input>
            }
            content="Add Options is restricted to 50 alphanumeric characters."
            open={this.state.showAddOptionsPopup}
            onOpen={this.handleAddOptionPopUpOpen.bind(this)}
            inverted
            onClose={this.handleAddOptionPopUpClose.bind(this)}
          ></Popup>

          <Input
            type="text"
            icon="search"
            placeholder="Search Options"
            className="mt-8 mb-8  fluid"
            onChange={this.handleSearchFieldChange.bind(this)}
            value={this.state.searchEnteredValue}
          />
          {_optionsList}
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={this.onClickCancelHandler.bind(this)}
          >
            Cancel
          </Button>
          <Button primary onClick={this.onClickApplyHandler.bind(this)}>
            Apply
          </Button>
        </Modal.Actions>
      </Modal >
    );
  }
}

function mapStateToProps(state) {
  return {
    isCfieldsedited: state.customFieldsReducer.isCustomFieldEdited,
    firmCustomFields: state.customFieldsReducer.firmCustomFields,
    originalFirmCustomFields:
      state.customFieldsReducer.originalFirmCustomFields,
    createNotification: state.customFieldsReducer.createNotification
  };
}

function mapDistpatchToProps(dispatch) {
  return bindActionCreators(
    {
      saveCustomField,
      resetCustomField,
      createNotification,
      customFieldEdited
    },
    dispatch
  );
}
export default connect(mapStateToProps, mapDistpatchToProps)(DropDownSettings);
